import { render, staticRenderFns } from "./OrderDraftSummary.vue?vue&type=template&id=19195a6d&"
import script from "./OrderDraftSummary.vue?vue&type=script&lang=js&"
export * from "./OrderDraftSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports